import { type ParseKeys } from 'i18next';
import { DEFAULT_OPTIONS } from '@pkgs/api/utils/filters';
import { type Currency, Language, MeasurementSystem } from '@pkgs/api';

export const mapLanguageCode: Record<
  Language | 'cimode',
  {
    translationKey: ParseKeys<'common'>;
    value: Language;
  }
> = {
  [Language.de]: {
    translationKey: 'search.globalSettings.languages.german',
    value: Language.de,
  },
  [Language.en]: {
    translationKey: 'search.globalSettings.languages.english',
    value: Language.en,
  },
  [Language.fr]: {
    translationKey: 'search.globalSettings.languages.french',
    value: Language.fr,
  },
  [Language.it]: {
    translationKey: 'search.globalSettings.languages.italian',
    value: Language.it,
  },
  [Language.es]: {
    translationKey: 'search.globalSettings.languages.spanish',
    value: Language.es,
  },
  [Language.el]: {
    translationKey: 'search.globalSettings.languages.greek',
    value: Language.el,
  },
  [Language.da]: {
    translationKey: 'search.globalSettings.languages.danish',
    value: Language.da,
  },
  [Language.pt]: {
    translationKey: 'search.globalSettings.languages.portuguese',
    value: Language.pt,
  },
  [Language.ca]: {
    translationKey: 'search.globalSettings.languages.catalan',
    value: Language.ca,
  },
  [Language.cs]: {
    translationKey: 'search.globalSettings.languages.czech',
    value: Language.cs,
  },
  [Language.nl]: {
    translationKey: 'search.globalSettings.languages.dutch',
    value: Language.nl,
  },
  [Language.hu]: {
    translationKey: 'search.globalSettings.languages.hungarian',
    value: Language.hu,
  },
  [Language.hr]: {
    translationKey: 'search.globalSettings.languages.croatian',
    value: Language.hr,
  },
  [Language.pl]: {
    translationKey: 'search.globalSettings.languages.polish',
    value: Language.pl,
  },
  ['cimode']: {
    translationKey: 'search.globalSettings.languages.english',
    value: Language.en,
  },
};

enum UnitSymbolEnum {
  MT = 'm²',
  FT = 'sq ft',
}

export const mapMeasurementSymbol: Record<MeasurementSystem, UnitSymbolEnum> = {
  [MeasurementSystem.metric]: UnitSymbolEnum.MT,
  [MeasurementSystem.imperial]: UnitSymbolEnum.FT,
};

export const mapLanguageTranslation: Record<Language, string> = {
  [Language.ca]: 'language.catalan',
  [Language.cs]: 'language.czech',
  [Language.da]: 'language.danish',
  [Language.de]: 'language.german',
  [Language.en]: 'language.english',
  [Language.el]: 'language.greek',
  [Language.es]: 'language.spanish',
  [Language.fr]: 'language.french',
  [Language.it]: 'language.italian',
  [Language.pt]: 'language.portuguese',
  [Language.nl]: 'language.dutch',
  [Language.hu]: 'language.hungarian',
  [Language.hr]: 'language.croatian',
  [Language.pl]: 'language.polish',
};

export const defaultSettingsByLang: Record<Language, { currency: Currency; measurementSystem: MeasurementSystem }> = {
  [Language.de]: {
    currency: DEFAULT_OPTIONS.currency,
    measurementSystem: DEFAULT_OPTIONS.measurementSystem,
  },
  [Language.en]: {
    currency: DEFAULT_OPTIONS.currency,
    measurementSystem: DEFAULT_OPTIONS.measurementSystem,
  },
  [Language.fr]: {
    currency: DEFAULT_OPTIONS.currency,
    measurementSystem: DEFAULT_OPTIONS.measurementSystem,
  },
  [Language.it]: {
    currency: DEFAULT_OPTIONS.currency,
    measurementSystem: DEFAULT_OPTIONS.measurementSystem,
  },
  [Language.es]: {
    currency: DEFAULT_OPTIONS.currency,
    measurementSystem: DEFAULT_OPTIONS.measurementSystem,
  },
  [Language.el]: {
    currency: DEFAULT_OPTIONS.currency,
    measurementSystem: DEFAULT_OPTIONS.measurementSystem,
  },
  [Language.da]: {
    currency: DEFAULT_OPTIONS.currency,
    measurementSystem: DEFAULT_OPTIONS.measurementSystem,
  },
  [Language.pt]: {
    currency: DEFAULT_OPTIONS.currency,
    measurementSystem: DEFAULT_OPTIONS.measurementSystem,
  },
  [Language.ca]: {
    currency: DEFAULT_OPTIONS.currency,
    measurementSystem: DEFAULT_OPTIONS.measurementSystem,
  },
  [Language.cs]: {
    currency: DEFAULT_OPTIONS.currency,
    measurementSystem: DEFAULT_OPTIONS.measurementSystem,
  },
  [Language.nl]: {
    currency: DEFAULT_OPTIONS.currency,
    measurementSystem: DEFAULT_OPTIONS.measurementSystem,
  },
  [Language.hu]: {
    currency: DEFAULT_OPTIONS.currency,
    measurementSystem: DEFAULT_OPTIONS.measurementSystem,
  },
  [Language.hr]: {
    currency: DEFAULT_OPTIONS.currency,
    measurementSystem: DEFAULT_OPTIONS.measurementSystem,
  },
  [Language.pl]: {
    currency: DEFAULT_OPTIONS.currency,
    measurementSystem: DEFAULT_OPTIONS.measurementSystem,
  },
};
